import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AppRoutes from './routes';
import MobileBlocker from './presentation/components/MobileBlocker/MobileBlocker';
import './App.css';

// Create a premium custom Material UI theme that globally enforces 'Poppins'
const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h1: { fontFamily: '"Poppins", sans-serif' },
    h2: { fontFamily: '"Poppins", sans-serif' },
    h3: { fontFamily: '"Poppins", sans-serif' },
    h4: { fontFamily: '"Poppins", sans-serif' },
    h5: { fontFamily: '"Poppins", sans-serif' },
    h6: { fontFamily: '"Poppins", sans-serif' },
    subtitle1: { fontFamily: '"Poppins", sans-serif' },
    subtitle2: { fontFamily: '"Poppins", sans-serif' },
    body1: { fontFamily: '"Poppins", sans-serif' },
    body2: { fontFamily: '"Poppins", sans-serif' },
    button: { fontFamily: '"Poppins", sans-serif', textTransform: 'none' },
    caption: { fontFamily: '"Poppins", sans-serif' },
    overline: { fontFamily: '"Poppins", sans-serif' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: '"Poppins", "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: '"Poppins", sans-serif',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: '"Poppins", sans-serif',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"Poppins", sans-serif',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontFamily: '"Poppins", sans-serif',
        },
        secondary: {
          fontFamily: '"Poppins", sans-serif',
        },
      },
    },
  },
});

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isMobile ? (
        <MobileBlocker />
      ) : (
        <BrowserRouter basename={process.env.PUBLIC_URL || ''}>
          <AppRoutes />
        </BrowserRouter>
      )}
    </ThemeProvider>
  );
}

export default App;
